import React from 'react';
import { BackIcon, CloseIcon } from './icons';

/**
 * The one card on the left of the map.
 *
 * Every step of the flow — a parcel, its add form, its update diff, a drawn
 * selection, imports, a queue, a log — renders inside this same shell and
 * animates in place, so the view never opens a second panel beside the first.
 */
export default function SidePanel({ title, subtitle, actions, canBack, onBack, onClose, children }) {
    // An array when the heading needs more than one line under the title —
    // a named property puts its address on one of its own.
    const subtitleLines = [].concat(subtitle || []).filter(Boolean);

    return (
        <aside className="SidePanel">
            <div className="SidePanel-header">
                {canBack && (
                    <button type="button" className="SidePanel-back" onClick={onBack} aria-label="Back">
                        <BackIcon />
                    </button>
                )}
                <div className="SidePanel-heading">
                    <div className="SidePanel-title">{title}</div>
                    {subtitleLines.map((line, index) => (
                        <div
                            key={line}
                            // The last line is always where the parcel is; an
                            // address above it belongs to the name in the title.
                            className={'SidePanel-subtitle' + (index === subtitleLines.length - 1 ? ' SidePanel-subtitle--place' : '')}
                        >
                            {line}
                        </div>
                    ))}
                </div>
                <div className="SidePanel-actions">
                    {actions}
                    <button type="button" className="SidePanel-close" onClick={onClose} aria-label="Close">
                        <CloseIcon />
                    </button>
                </div>
            </div>

            {children}
        </aside>
    );
}
